import script from "./AmlakList.vue?vue&type=script&setup=true&lang=js"
export * from "./AmlakList.vue?vue&type=script&setup=true&lang=js"

import "./AmlakList.vue?vue&type=style&index=0&id=c95e1862&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c95e1862"]])

export default __exports__